export const DAASPHONE = '15225298'
export const callLink = (tel?: string) => `tel:${tel}`
export const TRACKING_URL = "/trk/"
export const TRACKING_URL_PREV = "/tracking/"
export const trackingDetailUrl = (tracking?: string) => `${TRACKING_URL}${tracking}/detail/`
